import Banner from 'components/Banner';
import CareerForm from 'components/FormSection/Forms/CareerForm';
import GradientText from 'components/GradientText';
import JobCards from 'components/JobCards';
import MarqueeGallery from 'components/MarqueeGallery';
import MissionAndValuesSection from 'components/MissionAndValuesSection';
import { careerData } from 'components/MissionAndValuesSection/mockData';
import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import careerBanner from 'images/career-banner.jpg';
import image from 'images/small-images-inside-text/career.jpg';

const Career = () => (
    <>
        <Banner image={careerBanner} buttonText="View open jobs">
            <GradientText size="middle" textColor="white">
                We’re always looking people <br />
                <em>to help us become better</em>
            </GradientText>
        </Banner>

        <section className="container">
            <div className="inner-container type-2">
                <div className="main-text-container">
                    <LabelButton>Career opportunities</LabelButton>
                    <GradientText>
                        Unifer as a medium-sized international
                        <img src={image} alt="decor" />
                        company offers <em>great opportunities for career growth</em>
                    </GradientText>
                    <div className="offset-left-4 max-width-760">
                        <GradientText size="super-small">
                            We are not saying that we are unique, but believe us, companies like ours are not that
                            common.
                        </GradientText>
                    </div>
                </div>
            </div>
        </section>

        <MissionAndValuesSection data={careerData} />

        <section className="container">
            <div className="inner-container type-2">
                <div className="main-text-container">
                    <LabelButton>open jobs</LabelButton>
                    <div className="offset-left-4 max-width-760">
                        <GradientText size="middle">
                            Join our team and be part of the future of <em>agricultural success</em>
                        </GradientText>
                    </div>
                </div>
                <JobCards />
            </div>
        </section>

        <MarqueeGallery />

        <section className="container">
            <div className="inner-container type-3">
                <div className="main-text-container">
                    <LabelButton>Get in touch</LabelButton>
                    <GradientText size="middle">
                        If you would like to learn more about <em>career opportunities at our company,</em> please
                        contact us!
                    </GradientText>
                    <div className="offset-left-4 max-width-760">
                        <GradientText size="super-small">
                            Even if you haven't found your dream job on this page, we may still be able to offer you an
                            internship with us.
                        </GradientText>
                    </div>
                </div>
            </div>
        </section>

        <CareerForm />
    </>
);

export default Career;
